export default __webpack_public_path__ + "static/cascadr-logo-eb7bd26173bd9f1dd26667e8bdd6d3c9.png";